var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13.3399 7.13182L13.0906 13.3818H10.9046L10.6553 7.13182H13.3399ZM11.9976 17.1034C11.6269 17.1034 11.3089 16.974 11.0436 16.7151C10.7815 16.453 10.6521 16.135 10.6553 15.7611C10.6521 15.3967 10.7815 15.0851 11.0436 14.8262C11.3089 14.5674 11.6269 14.4379 11.9976 14.4379C12.3492 14.4379 12.6592 14.5674 12.9276 14.8262C13.1993 15.0851 13.3367 15.3967 13.3399 15.7611C13.3367 16.0104 13.2712 16.2373 13.1434 16.4418C13.0187 16.6432 12.8557 16.8046 12.6544 16.926C12.453 17.0443 12.2341 17.1034 11.9976 17.1034Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.27c7b9e731f918fad201dded52acdf91.svg";
export { ForwardRef as ReactComponent };